import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3, Users, Building2, Wallet, TrendingUp, ArrowUpRight, ArrowDownRight, Package, Clock, CheckCircle2, MoreHorizontal, Sparkles } from 'lucide-react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
const data = [{
  name: 'Jan',
  spend: 4000
}, {
  name: 'Feb',
  spend: 3000
}, {
  name: 'Mar',
  spend: 5000
}, {
  name: 'Apr',
  spend: 4500
}, {
  name: 'May',
  spend: 6000
}, {
  name: 'Jun',
  spend: 5500
}];
export function EnterpriseDashboard() {
  return <div className="min-h-[calc(100vh-5rem)] bg-surface-100 p-6 lg:p-8" data-id="element-1489">
      <div className="max-w-7xl mx-auto" data-id="element-1490">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4" data-id="element-1491">
          <div data-id="element-1492">
            <h1 className="text-3xl font-display font-bold text-gray-900" data-id="element-1493">
              Control Tower
            </h1>
            <p className="text-gray-500 mt-1" data-id="element-1494">Acme Corp Logistics Overview</p>
          </div>
          <div className="flex gap-3" data-id="element-1495">
            <button className="px-4 py-2 bg-white border border-gray-200 rounded-xl text-sm font-medium text-gray-700 hover:bg-gray-50 shadow-sm" data-id="element-1496">
              Download Report
            </button>
            <button className="px-4 py-2 bg-gray-900 text-white rounded-xl text-sm font-medium hover:bg-black shadow-sm" data-id="element-1497">
              New Shipment
            </button>
          </div>
        </div>

        {/* Stats Row */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-1498">
          {[{
          label: 'Total Spend (MTD)',
          value: 'AED 45,200',
          trend: '+12%',
          up: true,
          icon: Wallet
        }, {
          label: 'Active Shipments',
          value: '24',
          trend: '+4',
          up: true,
          icon: Package
        }, {
          label: 'Avg. Delivery Time',
          value: '1.4 hrs',
          trend: '-15%',
          up: true,
          icon: Clock
        }, {
          label: 'Cost per km',
          value: 'AED 2.8',
          trend: '+5%',
          up: false,
          icon: TrendingUp
        }].map((stat, i) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: i * 0.1
        }} key={stat.label} className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm" data-id="element-1499">
              <div className="flex justify-between items-start mb-4" data-id="element-1500">
                <div className="w-10 h-10 rounded-xl bg-gray-50 flex items-center justify-center" data-id="element-1501">
                  <stat.icon className="w-5 h-5 text-gray-600" data-id="element-1502" />
                </div>
                <span className={`flex items-center text-xs font-bold px-2 py-1 rounded-md ${stat.up ? 'text-green-700 bg-green-50' : 'text-red-700 bg-red-50'}`} data-id="element-1503">
                  {stat.up ? <ArrowUpRight className="w-3 h-3 mr-1" data-id="element-1504" /> : <ArrowDownRight className="w-3 h-3 mr-1" data-id="element-1505" />}
                  {stat.trend}
                </span>
              </div>
              <p className="text-sm text-gray-500 mb-1" data-id="element-1506">{stat.label}</p>
              <h3 className="text-2xl font-display font-bold text-gray-900" data-id="element-1507">
                {stat.value}
              </h3>
            </motion.div>)}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1508">
          {/* Chart Section */}
          <div className="lg:col-span-2 bg-white p-6 rounded-3xl border border-gray-100 shadow-sm" data-id="element-1509">
            <div className="flex justify-between items-center mb-6" data-id="element-1510">
              <h3 className="text-lg font-bold text-gray-900" data-id="element-1511">
                Logistics Spend
              </h3>
              <select className="bg-gray-50 border-none text-sm font-medium text-gray-600 rounded-lg px-3 py-1 outline-none cursor-pointer" data-id="element-1512">
                <option data-id="element-1513">Last 6 Months</option>
                <option data-id="element-1514">This Year</option>
              </select>
            </div>
            <div className="h-72 w-full" data-id="element-1515">
              <ResponsiveContainer width="100%" height="100%" data-id="element-1516">
                <AreaChart data={data} margin={{
                top: 10,
                right: 10,
                left: -20,
                bottom: 0
              }} data-id="element-1517">
                  <defs data-id="element-1518">
                    <linearGradient id="colorSpend" x1="0" y1="0" x2="0" y2="1" data-id="element-1519">
                      <stop offset="5%" stopColor="#14B8A6" stopOpacity={0.3} data-id="element-1520" />
                      <stop offset="95%" stopColor="#14B8A6" stopOpacity={0} data-id="element-1521" />
                    </linearGradient>
                  </defs>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f3f4f6" data-id="element-1522" />
                  <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                  fill: '#9ca3af',
                  fontSize: 12
                }} dy={10} data-id="element-1523" />
                  <YAxis axisLine={false} tickLine={false} tick={{
                  fill: '#9ca3af',
                  fontSize: 12
                }} data-id="element-1524" />
                  <Tooltip contentStyle={{
                  borderRadius: '12px',
                  border: 'none',
                  boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
                }} itemStyle={{
                  color: '#0A0A0A',
                  fontWeight: 'bold'
                }} data-id="element-1525" />
                  <Area type="monotone" dataKey="spend" stroke="#14B8A6" strokeWidth={3} fillOpacity={1} fill="url(#colorSpend)" data-id="element-1526" />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* AI Insights */}
          <div className="bg-gradient-to-br from-gray-900 to-gray-800 p-6 rounded-3xl text-white shadow-xl relative overflow-hidden" data-id="element-1527">
            <div className="absolute top-0 right-0 w-64 h-64 bg-brand-500 rounded-full blur-[80px] opacity-20 -translate-y-1/2 translate-x-1/3" data-id="element-1528"></div>

            <div className="flex items-center gap-2 mb-6 relative z-10" data-id="element-1529">
              <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center backdrop-blur-md" data-id="element-1530">
                <Sparkles className="w-4 h-4 text-brand-400" data-id="element-1531" />
              </div>
              <h3 className="text-lg font-bold" data-id="element-1532">AI Insights</h3>
            </div>

            <div className="space-y-4 relative z-10" data-id="element-1533">
              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-4 border border-white/10" data-id="element-1534">
                <p className="text-sm font-medium mb-1 text-brand-300" data-id="element-1535">
                  Cost Optimization
                </p>
                <p className="text-sm text-gray-300 leading-relaxed" data-id="element-1536">
                  Consolidating your Jebel Ali shipments on Tuesdays could save
                  approximately AED 4,200 monthly.
                </p>
                <button className="mt-3 text-xs font-bold text-white hover:text-brand-300 transition-colors" data-id="element-1537">
                  Apply Rule →
                </button>
              </div>

              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-4 border border-white/10" data-id="element-1538">
                <p className="text-sm font-medium mb-1 text-brand-300" data-id="element-1539">
                  Fleet Allocation
                </p>
                <p className="text-sm text-gray-300 leading-relaxed" data-id="element-1540">
                  You are over-utilizing 3-Ton trucks for loads under 1 Ton.
                  Switching to 1-Ton pickups recommended.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Active Shipments Table */}
        <div className="mt-8 bg-white rounded-3xl border border-gray-100 shadow-sm overflow-hidden" data-id="element-1541">
          <div className="p-6 border-b border-gray-100 flex justify-between items-center" data-id="element-1542">
            <h3 className="text-lg font-bold text-gray-900" data-id="element-1543">Live Operations</h3>
            <button className="text-brand-600 text-sm font-medium hover:text-brand-700" data-id="element-1544">
              View All
            </button>
          </div>
          <div className="overflow-x-auto" data-id="element-1545">
            <table className="w-full text-left border-collapse" data-id="element-1546">
              <thead data-id="element-1547">
                <tr className="bg-gray-50 text-gray-500 text-xs uppercase tracking-wider" data-id="element-1548">
                  <th className="p-4 font-medium" data-id="element-1549">ID</th>
                  <th className="p-4 font-medium" data-id="element-1550">Route</th>
                  <th className="p-4 font-medium" data-id="element-1551">Carrier</th>
                  <th className="p-4 font-medium" data-id="element-1552">Status</th>
                  <th className="p-4 font-medium" data-id="element-1553">Cost</th>
                  <th className="p-4 font-medium" data-id="element-1554"></th>
                </tr>
              </thead>
              <tbody className="text-sm divide-y divide-gray-100" data-id="element-1555">
                {[{
                id: 'SHP-001',
                route: 'DXB → AUH',
                carrier: 'FastTrack',
                status: 'In Transit',
                cost: 'AED 450'
              }, {
                id: 'SHP-002',
                route: 'JAFZA → Marina',
                carrier: 'SafeMove',
                status: 'Loading',
                cost: 'AED 280'
              }, {
                id: 'SHP-003',
                route: 'SHJ → DXB',
                carrier: 'Premium Log',
                status: 'Scheduled',
                cost: 'AED 320'
              }].map(row => <tr key={row.id} className="hover:bg-gray-50/50 transition-colors" data-id="element-1556">
                    <td className="p-4 font-medium text-gray-900" data-id="element-1557">{row.id}</td>
                    <td className="p-4 text-gray-600" data-id="element-1558">{row.route}</td>
                    <td className="p-4 text-gray-600" data-id="element-1559">{row.carrier}</td>
                    <td className="p-4" data-id="element-1560">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${row.status === 'In Transit' ? 'bg-blue-50 text-blue-700' : row.status === 'Loading' ? 'bg-amber-50 text-amber-700' : 'bg-gray-100 text-gray-700'}`} data-id="element-1561">
                        {row.status}
                      </span>
                    </td>
                    <td className="p-4 font-medium text-gray-900" data-id="element-1562">
                      {row.cost}
                    </td>
                    <td className="p-4 text-right" data-id="element-1563">
                      <button className="text-gray-400 hover:text-gray-600" data-id="element-1564">
                        <MoreHorizontal className="w-5 h-5" data-id="element-1565" />
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>;
}